import React, {useState} from 'react';
import {Button, Table} from 'antd';
import {format, isDate} from 'date-fns';
import CommentsDialog from './CommentsDialog';
import {useCSContext} from 'Context/ContentStackContext';
import {DATE_FORMAT} from 'Utils/constants/DateFormat';
import {SR_DASHBOARD} from 'Pages/SRDashboard/srDashboardConstants';

interface IProps {
  SRList: any;
}

// HeaderRow.tsx/CustomRow.tsx were folded in here — this table's shape is fixed
// (SR_DASHBOARD.result_row) rather than the generic, config-driven shape
// Components/TableView handles, so a single antd Table with named columns is a
// more direct fit than trying to reuse that positional-pairing component.
const CommentsCell = ({comments}: {comments?: string}) => {
  const {artifacts} = useCSContext();
  const [openCommentsDialog, setOpenCommentsDialog] = useState(false);

  if (!comments) return null;

  return (
    <>
      <Button
        type="text"
        size="small"
        onClick={() => setOpenCommentsDialog(true)}
        icon={<img src={artifacts.more_icon} alt="comments" />}
      />
      <CommentsDialog
        openCommentsDialog={openCommentsDialog}
        setOpenCommentsDialog={setOpenCommentsDialog}
        comments={comments}
      />
    </>
  );
};

const columns = [
  ...SR_DASHBOARD.result_row.map((header: any) => ({
    title: header.label,
    dataIndex: header.name,
    key: header.name,
    render:
      header.name === 'createdOn'
        ? (value: any) =>
            value && isDate(new Date(value)) ? format(new Date(value), DATE_FORMAT.dateFormat) : ''
        : undefined,
  })),
  {
    title: '',
    key: 'comments',
    render: (_: any, row: any) => <CommentsCell comments={row.comments} />,
  },
];

const ResultsTable: React.FC<IProps> = (props) => {
  const {SRList} = props;
  return (
    <Table
      style={{marginBottom: 32}}
      columns={columns}
      dataSource={SRList}
      rowKey={(_, index) => index ?? 0}
      pagination={false}
    />
  );
};

export default ResultsTable;
